export default __webpack_public_path__ + "51c1993688cd667d289a441093ec9efc.svg";